<template>
    <div class="wrapper wrapper-content animated fadeInRight">
        <div class="ibox-content m-b-sm border-bottom">
            <div class="row form-horizontal">
                <div class="form-group margin-0">
                    <label class="col-sm-2 control-label"> Action </label>
                    <div class="col-sm-4">
                        <div>
                            <el-select @clear="search" v-model="action" v-bind:placeholder='$t("message.PleaseSelect")'>
                                <el-option v-for="item in actionList" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                </div>
                <div class="form-group margin-0">
                    <label class="col-sm-2 control-label"> Member No. </label>
                    <div class="col-sm-4">
                        <div>
                            <el-input v-model="memberNo" name="search" clearable @clear="search"></el-input>
                        </div>
                    </div>
                </div>
                <div class="form-group margin-0">
                    <label class="col-sm-2 control-label"> Create Date & Time </label>
                    <div class="col-sm-4">
                        <div>
                            <el-date-picker v-model="selectDate" type="daterange" start-placeholder="Start date"
                                end-placeholder="End date">
                            </el-date-picker>
                        </div>
                    </div>
                </div>
                <div class="form-group margin-0">
                    <label class="col-sm-2 control-label">
                        Batch Uuid
                    </label>
                    <div class="col-sm-4">
                        <div>
                            <el-input v-model="batchUuid" name="search" clearable @clear="search"></el-input>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <div class="col-sm-12 textRight">
                        <div class>
                            <el-button type="primary" @click="search">{{
                                $t("message.Search")
                            }}</el-button>


                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <div class="ibox float-e-margins">
                    <div class="ibox-content">
                        <div class="row table-responsive" style="padding-bottom: 60px">
                            <div class="col-sm-12">
                                <div class="pull-right" style="display: flex;">
                                    <el-button @click="gotoDetail">{{
                                $t("message.Add")
                            }}</el-button>
                                    <el-upload class="upload-demo" action="#" style="margin:0 10px"
                                        :http-request="handleImport" :auto-upload="true" accept=".xlsx, .xls"
                                        :show-file-list="false">
                                        <el-button>Import</el-button>
                                    </el-upload>

                                </div>
                            </div>
                            <div class="col-xs-12">
                                {{ total }}{{ $t("message.datagridresult") }}
                            </div>
                            <el-table :data="rows" border style="width: 100%" ref="multipleTable" row-key="id">

                                <el-table-column prop="memberNo" label="Member No" width="170">
                                </el-table-column>
                                <el-table-column prop="stampQty" label="Quantity" width="170">
                                </el-table-column>
                                <el-table-column prop="action" label="Action Type" width="170">
                                    <template slot-scope="scope">
                                        {{ actionMap[scope.row.action] }}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="createdAt" label="Created At" width="190">
                                </el-table-column>
                                <el-table-column prop="batchUuid" label="Batch Uuid" width="190">
                                </el-table-column>
                                <el-table-column prop="remark" label="Remark">
                                </el-table-column>
                                <el-table-column label="Action" width="120" fixed="right">
                                    <template slot-scope="scope">
                                        <el-button size="mini" v-if="checkPermission('gift_inventory_log_VIEW')"
                                            @click="handleDbClick(scope.row)" icon="el-icon-edit"></el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <el-col :span="24" class="el-table_footertoolbar">
                                <el-pagination layout="total, sizes, prev, pager, next, jumper"
                                    @size-change="handleSizeChange" @current-change="handleCurrentChange"
                                    :page-sizes="[10, 20, 50, 100]" :page-size="pagesize" :total="total"
                                    style="float: right">
                                </el-pagination>
                            </el-col>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import config from "../config";
import axios from "axios"
export default {
    mixins: [config.globalMixin],
    data() {
        return {
            page: 1, //当前页数
            pagesize: 10, //一页显示几条
            total: 0,
            rows: [],
            action: "",
            memberNo: "",
            selectDate: [],
            batchUuid: ''
        };
    },
    components: {
    },
    computed: {
        actionMap() {
            return {
                1: "Increase",
                2: "Reduce",
            }
        },
        actionList() {
            return [
                { value: "", label: "All" },
                { value: 1, label: "Increase" },
                { value: 2, label: "Reduce" },
            ]
        }
    },
    created() {
    },
    methods: {
        async init() {
            var objdata = this.getAuthObj();

            objdata.pageIndex = this.page;
            objdata.pageSize = this.pagesize;
            objdata.action = this.action;
            objdata.memberNo = this.memberNo;
            objdata.begCreatedAt = this.selectDate && this.selectDate.length && this.selectDate[0] ? this.$dayjs(this.selectDate[0]).format("YYYY-MM-DD") : '';
            objdata.endCreatedAt = this.selectDate && this.selectDate.length && this.selectDate[0] ? this.$dayjs(this.selectDate[1]).format("YYYY-MM-DD") : '';
            objdata.batchUuid = this.batchUuid

            objdata.apiUrl = this.apiConfig.userStampUpdateLogList;
            let data = await this.$store.dispatch("apiEvent", objdata);
            if (data == "000104") {
                this.timeoutEvent();
                return;
            }
            if (!data) return;
            this.rows = data.data.result.userStampUpdateLogList;
            this.total = data.data.result.total;
        },
        async getRewardsList() {

        },
        async search() {
            this.init();
        },
        cancel: function () {
            this.$store.commit("setwarning", { string: "", boolean: false });
        },
        handleDbClick: function (row) {
            this.$router.push({
                path: "/main/userStampUpdateLogDetail",
                query: {
                    id: row.id,
                },
            });
        },
        gotoDetail() {
            this.$router.push({ path: "/main/userStampUpdateLogDetail" });
        },
        async handleImport(params) {
            const that = this
            let obj = this.getAuthObj();
            obj.file = params.file;
            obj.apiUrl = this.apiConfig.userStampUpdateLogBatchCreate;
            var data = await this.$store.dispatch("apiEventFromData", obj);
            if (data == this.TOKEN_EXPIRED) {
                this.timeoutEvent();
                return;
            }
            if (!data) return;
            const isMemberNotFound = data.data.result.memberNotFound
            const isMemberDontHaveEnoughJCoin = data.data.result.memberDontHaveEnoughJCoin
            const isExceededJCoinLimit = data.data.result.exceededJCoinLimit
            const uuid = data.data.result.uuid
            let tipsText = ``
            if (isMemberNotFound && isMemberNotFound.length) {
                tipsText += 'The following member information were not found:\n'
                isMemberNotFound.forEach((item, index) => {
                    if (index != isMemberNotFound.length - 1) tipsText += `${item},`
                    else tipsText += `${item}\n\n`
                })
            }
            if (isMemberDontHaveEnoughJCoin && isMemberDontHaveEnoughJCoin.length) {
                tipsText += `The following members have insufficient J Coins for Deduction:\n`
                isMemberDontHaveEnoughJCoin.forEach((item, index) => {
                    if (index != isMemberDontHaveEnoughJCoin.length - 1) tipsText += `${item},`
                    else tipsText += `${item}\n\n`
                })
            }
            if (isExceededJCoinLimit && isExceededJCoinLimit.length) {
                tipsText += `The following members have J Coins exceeding J Coins Limit:\n`
                isExceededJCoinLimit.forEach((item, index) => {
                    if (index != isExceededJCoinLimit.length - 1) tipsText += `${item},`
                    else tipsText += `${item}\n\n`
                })
            }
            if (!(isExceededJCoinLimit && isExceededJCoinLimit.length && isMemberDontHaveEnoughJCoin && isMemberDontHaveEnoughJCoin.length && isMemberNotFound && isMemberNotFound.length)) {
                tipsText = `Import Success\nBatcb Uuid:${uuid}`
            }
            this.$store.commit("setwarning", {
                string: tipsText,
                boolean: true,
                button: [{
                    name: "Cancel",
                    callBack: function () { that.$store.commit("setwarning", { string: "", boolean: false }); }
                }]
            });
            this.init();
        },
    },
    mounted() {
        this.init();
    },

};
</script>